import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import MaestriaIcon from '../assets/images/maestria-icon.png';
import MaestriaActiveIcon from '../assets/images/maestria-active-icon.png';
import DoctoradoIcon from '../assets/images/doctorado-icon.png';
import DoctoradoActiveIcon from '../assets/images/doctorado-active-icon.png';
import ProgramaEspec from '../assets/images/programa-especializacion-icon.png';
import ProgramaActiveEspec from '../assets/images/programa-especializacion-active-icon.png';
import CursoEspec from '../assets/images/curso-especializacion-icon.png';
import CursoActiveEspec from '../assets/images/curso-especializacion-active-icon.png';
import { Tools } from '../utils/tools';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class ProgramsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasSubmission: false,
            submissions: [],
            current_idCampana: null,
            current_submission: null,
            pdegroup: ['PDE', 'LABS', 'LAB', 'CEX'],
            next_active: false,
            program_active: false,
            campanas: [],
            options: [
                { id: '', order: 1, code: '', idc: null, form: 1, show: false, icon_active: DoctoradoActiveIcon, icon: DoctoradoIcon, color: 'black', label: 'Doctorado', data: [] },
                { id: '', order: 2, code: '', idc: null, form: 1, show: false, icon_active: MaestriaActiveIcon, icon: MaestriaIcon, color: 'blue', label: 'Maestría', data: [] },
                { id: '', order: 3, code: '', idc: null, form: 2, show: false, icon_active: ProgramaActiveEspec, icon: ProgramaEspec, color: 'orange', label: 'Programa de Especialización', data: [] },
                { id: '', order: 4, code: '', idc: null, form: 2, show: false, icon_active: CursoActiveEspec, icon: CursoEspec, color: 'green', label: 'Curso de Especialización', data: [] }
            ],
            option_selected: null,
            oportunities: [],
            default_submission: null
        }
    }

    componentDidMount() {
        let _root = this;
        _root.setState({
            oportunities: _root.props.glo.oportunities
        });
    }

    onChange = async e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        _root.setState({ option_selected: _target.value });
        this.setState()
        
        let _option = _target.options[_target.selectedIndex];

        _root.setState({ option_selected: _target.value });
        this.props.pro.codOportunidad = "-1";
        if (_option.value === "-1") return;
        Tools.showPreloader();
        _root.props.glo.costo = 150;
        _root.props.glo.pacademico = _option.getAttribute('data-nomprograma');

        let _programSelected = ApiService.checkProgramType(_option.getAttribute('data-tipoprograma'));
        if (_programSelected !== null) {
            _programSelected.data = _root.props.glo.oportunities;
        }
        localStorage.setItem('app_sp', Tools.cryptrData(JSON.stringify(_programSelected)));

        let _submissions = [];
        let res = await ApiService.getData(`${APIS.submissionByEmail}${_root.props.pro.emailPersonal}`);
        _submissions = res.data;
        // if (localStorage.getItem('submissions')) {
        //     _submissions = JSON.parse(localStorage.getItem('submissions'));
        // }

        let submissionTypeProgram = _submissions.filter(e => 
            e.tipoPrograma === _option.getAttribute('data-tipoprograma') &&
            e.codPrograma === _option.getAttribute("data-codprograma")
        );
        if (submissionTypeProgram.length === 0) {
            //_root.props.pro.idProgramaAcademico = _option.getAttribute('data-codprograma');
            _root.props.pro.codOportunidad = _option.getAttribute('data-codoportunidad');
            _root.props.pro.codPrograma = _option.getAttribute('data-codprograma');
            _root.props.pro.codEjecutivo = _option.getAttribute('data-codejecutivo');
            _root.props.pro.nombreEjecutivo = _option.getAttribute('data-nombreejecutivo');
            _root.props.pro.correoEjecutivo = _option.getAttribute('data-correoejecutivo');
            _root.props.pro.nomPrograma = _option.getAttribute('data-nomprograma');
            _root.props.pro.nomTipoPrograma = _option.getAttribute('data-nomtipoprograma');
            _root.props.pro.tipoPrograma = _option.getAttribute('data-tipoprograma');
            _root.props.pro.periodo = _option.getAttribute('data-periodo');
            _root.props.pro.idSubmissionType = _programSelected.type;
            _root.props.pro.vistasCompletadas = '';
            _root.props.pro.id = 0;
            _root.props.pro.idSubmission = 0;
            _root.props.process(_root.props.pro);
        }
        else if (submissionTypeProgram.length === 1) {

            let item = submissionTypeProgram[0];
            let _submission = { ...item };
            _root.props.glo.userfindsub = null;
            _root.props.general(_root.props.glo);
            //_submission.idProgramaAcademico = _option.getAttribute('data-codprograma');
            _submission.codOportunidad = _option.getAttribute('data-codoportunidad');
            _submission.codPrograma = _option.getAttribute('data-codprograma');
            _submission.codEjecutivo = _option.getAttribute('data-codejecutivo');
            _submission.nombreEjecutivo = _option.getAttribute('data-nombreejecutivo');
            _submission.correoEjecutivo = _option.getAttribute('data-correoejecutivo');
            _submission.nomPrograma = _option.getAttribute('data-nomprograma');
            _submission.nomTipoPrograma = _option.getAttribute('data-nomtipoprograma');
            _submission.tipoPrograma = _option.getAttribute('data-tipoprograma');
            _submission.periodo = _option.getAttribute('data-periodo');
            _submission.id = item.id;
            _submission.idSubmission = item.idSubmission;
            _submission.idProgramaAcademico = item.idProgramaAcademico;
            _submission.idSubmissionType = _programSelected.type;
            _submission.idSubmissionState = item.idSubmissionState;
            _submission.idLeadPS = item.idLeadPS;
            _submission.vistasCompletadas = item.vistasCompletadas;
            _root.props.process(_submission);
        }
        else {
            console.log('VARIOS PROGRAMAS');
            //_submissions.length

        }
        _root.setState({
            next_active: true,
            hasSubmission: false
        });

        Tools.hidePreloader();
    }

    onBackToLogin = (e) => {
        e.preventDefault();
        window.location.href = '/';
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        let _idSubmissionState = _root.props.pro.idSubmissionState;

        if (this.state.option_selected === "-1") { return false }
        switch (_idSubmissionState) {
            case 6:
                Tools.showToaster('warning', '', 'Ud. ya finalizó la inscripción de este programa, seleccione otro.', 6000);
                break;
            case 5:
                Tools.showToaster('warning', '', 'Ud. no puede editar su información.', 6000);
                break;
            case 4:
                Tools.showToaster('warning', '', 'Ud. no puede editar su información.', 6000);
                break;
            default:
                let _arrpais = _root.props.glo.paises.filter((item) => { return (item.codigoPais === _root.props.pro.paisResidencia); });
                let _arrdpto = _root.props.glo.departamentos.filter((item) => { return (item.codigoDepartamento === _root.props.pro.idDepartamento); });
                let _arrprov = [];
                let _arrdist = [];

                if (_root.props.pro.paisResidencia === 'PER') {
                    if (_arrdpto.length > 0) {
                        Tools.showPreloader();
                        ApiService.getData(`${APIS.provincias}${_arrdpto[0].id}`)
                            .then((res) => {
                                _arrprov = res.data.filter((item) => { return (item.codigoProvincia === _root.props.pro.idProvincia); });

                                if (_arrprov.length > 0) {
                                    return ApiService.getData(`${APIS.distritos}${_arrprov[0].id}`);
                                }
                            })
                            .then((res) => {
                                _arrdist = res.data.filter((item) => { return (item.codigoDistrito === _root.props.pro.idDistrito); });

                                if (_arrpais.length > 0) {
                                    _root.props.pro.paisResidencia = _arrpais[0].id;
                                }
                                if (_arrdpto.length > 0) {
                                    _root.props.pro.idDepartamento = _arrdpto[0].id;
                                }
                                if (_arrprov.length > 0) {
                                    _root.props.pro.idProvincia = _arrprov[0].id;
                                }
                                if (_arrdist.length > 0) {
                                    _root.props.pro.idDistrito = _arrdist[0].id;
                                }

                                _root.props.process(_root.props.pro);

                                // Tools.showPreloader();
                                _root.props.general(_root.props.glo);
                                console.log("PER _arrdpto.length > 0", _root.props.pro);
                                ApiService.postData(`${APIS.submission}`, _root.props.pro)
                                    .then(res => {

                                        if (res.data.id !== undefined) {
                                            if (res.data.id !== 0) {
                                                _root.props.pro.id = res.data.id;
                                                _root.props.pro.idSubmission = res.data.idSubmission;
                                                _root.props.process(_root.props.pro);
                                                Tools.hidePreloader();
                                                _root.props.navigate('/datos-generales');
                                            }
                                            else {
                                                Tools.hidePreloader();
                                                Tools.showToaster('error', '', 'No se pudo mandar la información7, inténtalo de nuevo en unos minutos.', 3000);
                                            }
                                        }
                                        else {
                                            Tools.hidePreloader();
                                            Tools.showToaster('error', '', 'No se pudo mandar la información6, inténtalo de nuevo en unos minutos.', 3000);
                                        }
                                    })
                                    .catch(err => {
                                        Tools.hidePreloader();
                                        console.log(err);
                                    });

                            })
                            .catch((err) => {
                                Tools.hidePreloader();
                                Tools.showToaster('warning', '', 'Problemas de conexión, inténtelo de nuevo en unos minutos.', 6000);
                            });
                    }
                    else {
                        Tools.showPreloader();
                        if (_arrpais.length > 0) {
                            _root.props.pro.paisResidencia = _arrpais[0].id;
                        }
                        _root.props.process(_root.props.pro);
                        _root.props.general(_root.props.glo);
                        console.log("PER _arrdpto.length = 0", _root.props.pro);
                        ApiService.postData(`${APIS.submission}`, _root.props.pro)
                            .then(res => {

                                if (res.data.id !== undefined) {
                                    if (res.data.id !== 0) {
                                        _root.props.pro.id = res.data.id;
                                        _root.props.pro.idSubmission = res.data.idSubmission;
                                        _root.props.process(_root.props.pro);
                                        Tools.hidePreloader();
                                        _root.props.navigate('/datos-generales');
                                    }
                                    else {
                                        Tools.hidePreloader();
                                        Tools.showToaster('error', '', 'No se pudo mandar la información4, inténtalo de nuevo en unos minutos.', 3000);
                                    }
                                }
                                else {
                                    Tools.hidePreloader();
                                    Tools.showToaster('error', '', 'No se pudo mandar la información5, inténtalo de nuevo en unos minutos.', 3000);
                                }
                            })
                            .catch(err => {
                                Tools.hidePreloader();
                                console.log(err);
                            });
                    }
                }
                else {
                    if (_arrpais.length > 0) {
                        _root.props.pro.paisResidencia = _arrpais[0].id;
                    }

                    _root.props.process(_root.props.pro);

                    Tools.showPreloader();
                    _root.props.general(_root.props.glo);
                    console.log("!PER ", _root.props.pro);
                    console.log('INFOR');
                    ApiService.postData(`${APIS.submission}`, _root.props.pro)
                        .then(res => {

                            if (res.data.id !== undefined) {
                                if (res.data.id !== 0) {
                                    _root.props.pro.id = res.data.id;
                                    _root.props.pro.idSubmission = res.data.idSubmission;
                                    _root.props.process(_root.props.pro);
                                    Tools.hidePreloader();
                                    _root.props.navigate('/datos-generales');
                                }
                                else {
                                    Tools.hidePreloader();
                                    Tools.showToaster('error', '', 'No se pudo mandar la información2, inténtalo de nuevo en unos minutos.', 3000);
                                }
                            }
                            else {
                                Tools.hidePreloader();
                                Tools.showToaster('error', '', 'No se pudo mandar la información3, inténtalo de nuevo en unos minutos.', 3000);
                            }
                        })
                        .catch(err => {
                            Tools.hidePreloader();
                            console.log(err);
                        });
                }

                break;
        }
    }

    render() {
        const {
            next_active,
            option_selected,
            program_active,
            oportunities
        } = this.state;

        return (
            <>
                <div className="programs">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="top">
                                    <a className="btn-style-3 mb-3" href="/#" onClick={this.onBackToLogin}><i className="fa fa-arrow-left" aria-hidden="true"></i> Atrás</a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="text-center text-bold">Selecciona tu programa de interés<br />para comenzar este camino juntos.</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    {
                                        (oportunities.length > 0) &&
                                        <div className="col-sm-12 mt-4">
                                            <div style={{ width: '90%', margin: '0 auto', letterSpacing: '1px' }}>
                                                <span><strong>Señala cuál es tu elección.</strong></span>
                                                <br />
                                                <div className="form-group mt-1 mb-2">
                                                </div>
                                                <div className="form-group pb-2">

                                                    <select className="form-control" id="idProgramaAcademico" name="idProgramaAcademico" value={this.props.pro.codOportunidad} onChange={this.onChange}>
                                                        <option value={"-1"}>Selecciona una opción</option>
                                                        {
                                                            oportunities.map((item, i) => (
                                                                <option key={(item.codOportunidad) + '-lc'}
                                                                    data-periodo={item.periodo}
                                                                    data-codoportunidad={item.codOportunidad}
                                                                    data-ciclolectivo={item.cicloLectivo}
                                                                    data-codprograma={item.codPrograma}
                                                                    data-tipoprograma={item.tipoPrograma}
                                                                    data-nomprograma={item.nomPrograma}
                                                                    data-nomtipoprograma={item.nomTipoPrograma}
                                                                    data-codejecutivo={item.owner.codEjecutivo}
                                                                    data-nombreejecutivo={item.owner.nombreEjecutivo}
                                                                    data-correoejecutivo={item.owner.correoEjecutivo}
                                                                    value={item.codOportunidad}>{item.nomPrograma}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-sm-12 col-md-9 offset-md-2" style={{ textAlign: 'right', marginTop: '4rem' }}>
                                        <button className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'} onClick={this.onClickNext}>Continuar <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-9 offset-md-2" style={{ textAlign: 'center', marginTop: '4rem' }}>
                                <button className="btn btn-primary btn-style-8" onClick={this.onBackToLogin}>Cerrar sesión</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramsComponent);